export interface IReservation {
  qrticketId: number;
  startDate?: Date;
  limitMonthDate?: Date;
  reservationDate?: Date;
  schedule: string;
  reservationPerson: string;
  startTime1?: Date;
  deleteFlagEnum: string;
}

export interface IReservationFilters {
  reservationDate?: Date;
}

export class ReservationFiltersFormValues implements IReservationFilters {
  reservationDate?: Date = undefined;

  constructor(init?: IReservationFilters) {
    Object.assign(this, init);
  }
}
